export const ArrowLeft = () => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.274948 6.47611C0.275228 6.47639 0.275463 6.47672 0.275791 6.477L5.17442 11.352C5.54141 11.7172 6.13498 11.7158 6.50028 11.3488C6.86553 10.9818 6.86412 10.3883 6.49714 10.023L3.2082 6.75L23.0625 6.75C23.5803 6.75 24 6.33028 24 5.8125C24 5.29472 23.5803 4.875 23.0625 4.875L3.20825 4.875L6.49709 1.602C6.86408 1.23675 6.86548 0.643171 6.50023 0.276187C6.13494 -0.0908922 5.54131 -0.0921577 5.17437 0.273L0.275745 5.148C0.275463 5.14828 0.275228 5.14861 0.2749 5.14889C-0.0922723 5.51536 -0.0910993 6.11086 0.274948 6.47611Z"
        fill="#FF6B08"
      />
    </svg>
  );
};
